import React from "react"
import tenYearsLogo from "../../../../images/10 years in business.svg"
import confettie from "../../../../images/Confettie.svg"
import "./tenYearsInBusiness.scss"
import { Link } from "gatsby"

function TenYearsInBusiness() {
  return (
    <div className="ten-years-in-business-section">
      <img src={confettie} alt="confettie image" className="confettie" />
      <div className="ten-years-in-business-logo">
        <img src={tenYearsLogo} alt="10 years in business" className="logo" />
      </div>
      <div className="ten-years-in-business-title">
        <h2>A Decade Delivering Innovation</h2>
        <p>
          with <span>Fortune 500s</span> & Digital Natives{" "}
          <Link
            style={{
              textDecoration: "underline",
              fontWeight: "400",
              paddingLeft: "10px",
            }}
            to="/awards-and-recognition/"
          >
            Learn more
          </Link>
        </p>
      </div>
    </div>
  )
}

export default TenYearsInBusiness
